import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowLeft } from 'lucide-react';
import '../components/LegalEditor.css';

const CGU = () => {
  const { t, i18n } = useTranslation();
  const [legalData, setLegalData] = useState(null);

  useEffect(() => {
    let cancelled = false;
    fetch(`/infofluo/legal.json?v=${Date.now()}`)
      .then(r => { if (!r.ok) throw r; return r.json(); })
      .then(d => { if (!cancelled) setLegalData(d); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  const lang = (i18n.language || 'fr').slice(0, 2);
  const page = legalData?.cgu?.[lang] ?? legalData?.cgu?.fr;

  return (
    <div className="bg-slate-50 min-h-[60vh] py-12">
      <div className="max-w-3xl mx-auto px-4 sm:px-6">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-slate-500 hover:text-ter-blue mb-8 transition-colors">
          <ArrowLeft className="w-4 h-4" />
          {t('legal.back')}
        </Link>

        <h1 className="text-3xl font-bold text-slate-900 mb-2">
          {page?.title ?? t('legal.cgu_title')}
        </h1>
        <p className="text-xs text-slate-400 mb-10">{t('legal.updated')}</p>

        <section className="bg-white rounded-xl border border-slate-100 p-6 shadow-sm">
          {page?.content ? (
            <div
              className="legal-content"
              dangerouslySetInnerHTML={{ __html: page.content }}
            />
          ) : (
            <div className="space-y-5">
              <div>
                <h2 className="text-base font-semibold text-slate-800 mb-2">{t('legal.cgu_object_title')}</h2>
                <p className="text-sm text-slate-600 leading-relaxed">{t('legal.cgu_object_body')}</p>
              </div>
              <div>
                <h2 className="text-base font-semibold text-slate-800 mb-2">{t('legal.cgu_access_title')}</h2>
                <p className="text-sm text-slate-600 leading-relaxed">{t('legal.cgu_access_body')}</p>
              </div>
              <div>
                <h2 className="text-base font-semibold text-slate-800 mb-2">{t('legal.cgu_ip_title')}</h2>
                <p className="text-sm text-slate-600 leading-relaxed">{t('legal.cgu_ip_body')}</p>
              </div>
              <div>
                <h2 className="text-base font-semibold text-slate-800 mb-2">{t('legal.cgu_liability_title')}</h2>
                <p className="text-sm text-slate-600 leading-relaxed">{t('legal.cgu_liability_body')}</p>
              </div>
            </div>
          )}
        </section>
      </div>
    </div>
  );
};

export default CGU;
